import Base from '../Base';

const url = '/faq-questions';

const STATUSES = {
  request: 1,
  canceled: 2,
  draft: 3,
  active: 4,
};
const STATUSES_COLORS = {
  [STATUSES.request]: 'warning',
  [STATUSES.canceled]: 'error',
  [STATUSES.draft]: 'secondary lighten-1',
  [STATUSES.active]: 'success',
};
const STATUSES_TEXT = {
  [STATUSES.request]: 'Заявка',
  [STATUSES.canceled]: 'Отклонена',
  [STATUSES.draft]: 'Черновик',
  [STATUSES.active]: 'Опубликовано',
};

export default class UnitFaq extends Base {
  constructor(item) {
    super(item.id, url);
    this.question = item.question;
    this.answer = item.answer.answer;
    this.status = item.status;
    this.owner = item.owner || {};
    this.sort_order = item.sort_order;
  }

  get statusData() {
    return {
      color: STATUSES_COLORS[this.status],
      text: STATUSES_TEXT[this.status],
    };
  }
}
